/**
 * Sample client onboarding handler
 * Handles the creation of sample clients and coordination with the extension
 */

import { showNotification } from "@mantine/notifications";

/**
 * Trigger sample client onboarding - creates a sample client and opens the extension
 *
 * @returns Promise<boolean> - True if successful, false otherwise
 */
export const triggerSampleClientOnboarding = async (): Promise<boolean> => {
  try {
    const { createSampleClient } =
      await import("@pages/Onboarding/api/taxOfficeApi");

    console.log("Creating sample client...");
    const response = await createSampleClient();

    if (response.clients.length > 0) {
      const client = response.clients[0];
      console.log("Sample client created:", client);

      // Send message to extension to start onboarding
      window.postMessage(
        {
          type: "START_SAMPLE_CLIENT_ONBOARDING",
          clientId: client.clientId,
          clientName: client.clientName,
          clientSSN: client.clientSSN,
        },
        window.location.origin
      );

      console.log("Message sent to extension");

      // Wait a bit to see if extension responds
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Show success notification
      showNotification({
        title: "Sample Client Created",
        message:
          "Opening extension... If nothing happens, refresh the page and try again.",
        color: "green",
        autoClose: 3000,
      });

      return true;
    } else {
      console.error("No sample clients were created");
      showNotification({
        title: "Error",
        message: "Failed to create sample client. Please try again.",
        color: "red",
      });
      return false;
    }
  } catch (error) {
    console.error("Failed to create sample client:", error);
    showNotification({
      title: "Error",
      message: "Failed to create sample client. Please try again.",
      color: "red",
    });
    return false;
  }
};
